import { ReportIssue } from "./ReportIssue";
import { useState } from "react";
import Sidebar, { MobileTopBar } from "./Sidebar";
import KitchenAlertBar from "./KitchenAlertBar";
import { useAuth } from "../context/AuthContext";

export default function Layout({ children }) {
  const { user } = useAuth();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  return (
    <div className="min-h-screen flex bg-background">
      <Sidebar mobileOpen={mobileNavOpen} onClose={() => setMobileNavOpen(false)} />
      <div className="flex-1 flex flex-col min-w-0">
        <MobileTopBar onOpenMenu={() => setMobileNavOpen(true)} />
        <main className="flex-1 px-6 sm:px-10 py-8 sm:py-10 pb-24 sm:pb-24 overflow-x-hidden">
          {children}
          <ReportIssue />
        </main>
      </div>
      {user?.role === "employee" && <KitchenAlertBar />}
    </div>
  );
}

export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <header className="mb-8 flex flex-wrap items-end justify-between gap-4">
      <div>
        {eyebrow && <div className="label-eyebrow mb-2">{eyebrow}</div>}
        <h1 className="font-display text-3xl sm:text-4xl font-light tracking-tight">{title}</h1>
        {description && (
          <p className="text-muted-foreground mt-2 max-w-2xl">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </header>
  );
}
